<template>
  <div>
    <el-card v-loading="loading" :body-style="{ padding: '0' }">
      <div class="table-content">
        <el-checkbox-group v-model="checkedRoutes" :max="maxChecked">
          <el-table size="mini" height="532" tooltip-effect="dark" style="font-size: 10px;"
            :cell-style="{ padding: '2px', height: '44px' }" ref="multipleTable" :data="visibleTableData">
            <el-table-column width="100">
              <!-- eslint-disable-next-line vue/no-unused-vars -->
              <template slot="header" slot-scope="scope">
                RUTAS <span :class="checkedCountColor"> ( {{ checkedCount }} ) </span>
              </template>
              <template slot-scope="scope">
                <div class="select-routes">
                  <el-checkbox :label="scope.row.id" v-if="scope.row.loadData"><span /></el-checkbox>
                  <i class="el-icon-loading" style="font-size: 14px;" v-else />
                  {{ scope.row.id }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="PATENTE" align="left" width="110">
              <template slot-scope="scope">
                <div class="change-plate">
                  <el-link @click="changePlate(scope.row.id, scope.row.plate)"
                    :disabled="scope.row.active || !scope.row.loadData">
                    <i class="fas fa-truck" />
                  </el-link>
                  <span>{{ scope.row.plate }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="KM" width="80" align="left">
              <template slot-scope="scope">
                <span > {{ scope.row.km}} </span>
              </template>
            </el-table-column>
            <el-table-column label="CAPACIDAD" width="80" align="left">
              <template slot-scope="scope">
                <span class="volume-percent">{{ scope.row.volume }} % </span>
                <div v-if="scope.row.loadData && checkedRoutes.includes(scope.row.id)">
                  <el-button size="mini" type="text" class="select-all-soc" @click="selectedAllPoint(scope.row.id)">
                    <span v-if="routesSelectAll.includes(scope.row.id)" class="all-color">
                      ({{ scope.row.soc }})
                    </span>
                    <span v-else>({{ scope.row.soc }})</span>
                  </el-button>
                </div>
                <div v-else>({{ scope.row.soc }})</div>
              </template>
            </el-table-column>
            <el-table-column property="tim" align="center" show-overflow-tooltip min-width="40" label="TIM">
              <template slot-scope="scope">
                <el-button v-if="scope.row.loadData && !scope.row.active && !scope.row.confirmed" type="text"
                  style="color: #AAD500" @click="dialogEditS(scope.row)">
                  <i style="font-size: 15px" class="el-icon-edit" />
                </el-button>
                <el-button v-else type="text" style="background-color: transparent !important;
                                border: transparent !important; padding: 0 !important;" disabled>
                  <i style="font-size: 15px" class="el-icon-edit" />
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="REP" property="modified" align="center" min-width="46">
              <template slot-scope="scope" style="text-align: center;">
                <span v-if="!scope.row.active && scope.row.modified">
                  <el-button v-if="scope.row.replanning_state === 0
                  || scope.row.replanning_state === -1" slot="reference" style="background-color: transparent !important;
                           border: transparent; font-size: 20px; padding: 0;" type="text" plain
                    v-model="scope.row.modified" @click="changeReplanning(scope.row)">
                    <i class="el-icon-refresh-right refresh-send" />
                  </el-button>
                  <i v-else-if="scope.row.replanning_state === 1" slot="reference" class="el-icon-loading"
                    style="font-size: 15px;" />
                  <i v-else-if="scope.row.replanning_state === 2" slot="reference"
                    class="el-icon-refresh-right rotate-1" style="font-size: 15px;" />
                </span>
                <div v-else style="text-align: center">—</div>
              </template>
            </el-table-column>
            <el-table-column label="ESTADO" align="center" width="110">
              <el-button class="default btn-confirmed" slot-scope="scope"
                v-if="[false, null].includes(scope.row.confirmed)" :disabled="scope.row.confirmed === null"
                @click="confirmedRoute(scope.row)">
                confirmar
              </el-button>
              <el-button class="default btn-active" slot-scope="scope" v-else
                :disabled="scope.row.active || scope.row.finalized" @click="activeRoute(scope.row)">
                {{ scope.row.active && scope.row.rtdb_uid !== null ? 'activo' : 'activar' }}
              </el-button>
            </el-table-column>
            <el-table-column label="DESACTIVAR RUTA" align="center" width="110">
              <el-button class="default btn-confirmed" slot-scope="scope" :disabled="scope.row.active === false"
                @click="deactivateRoute(scope.row)">
                desactivar
              </el-button>
            </el-table-column>
          </el-table>
        </el-checkbox-group>
      </div>
    </el-card>
  </div>
</template>


<script>
import { apiRequest } from '@/backend/vue-axios/axios';
import { getRumDuration, startRumTiming, trackBusinessFlow } from '@/observability/datadogRum';

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    sectors: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedMarkId: {
      type: Array,
      default() {
        return [];
      },
    },
    routesSelectAll: {
      type: Array,
      default() {
        return [];
      },
    },
    loadingRoutes: {
      type: Boolean,
      default: true,
    },
  },
  name: 'routes',
  components: {
  },
  data() {
    return {
      loading: this.loadingRoutes,
      tableData: [],
      subOrderList: [],
      checkedRoutes: [],
      editing: null,
      maxChecked: 10,
      colors: [
        '#ef5fdd',
        '#00e8b1',
        '#deae00',
      ],
      routeColors: [],
    };
  },
  watch: {
    loadingRoutes(value) {
      this.loading = value;
    },
    value() {
      this.setData();
    },
    checkedRoutes() {
      if (this.maxChecked === this.checkedCount) {
        this.$message
          .info('Se alcanzo el máximo de rutas seleccionables al mismo tiempo');
      }
      const dataLoad = this.visibleTableData
        .filter(r => r.loadData && this.checkedRoutes.includes(r.id));
      if (dataLoad.length < this.checkedCount) {
        this.$message
          .info('Hay carga de datos en proceso, sólo se mostrarán las rutas cargadas');
      }
      this.$emit('getSelected', dataLoad);
    },
  },
  mounted() {
    this.setData();
    this.$root.$on("route-messure",(msg) =>{
      var arr = msg.split("/")
      this.tableData.forEach((element,index) => {
        if (element.id=== Number(arr[1])){
          if (this.tableData[index].km !== "" || this.tableData[index].km !== "0.0 km") {
            this.tableData[index].km = arr[0]
            this.tableData[index].plate = "   " + this.tableData[index].plate + " "
          }
          return
        }
      })
    })
  },
  methods: {
    setData() {
      this.tableData = this.value;
    },
    checkOrders(commandType) {
      this.dialogEditSoc = false;
      const ordersError = [];
      this.cleanOrdersTo();
      let withError = false;
      let textAreaContent = '';
      if (commandType === 'tim') {
        if (this.textareaTim.trim() === '') {
          this.$notify.error({
            title: 'Error',
            message: 'El campo de TIM no puede estar vacío',
          });
          withError = true;
        } else {
          textAreaContent = this.textareaTim.trim();
        }
      }
      if (commandType === 'add') {
        if (this.textareaAdd.trim() === '') {
          this.$notify.error({
            title: 'Error',
            message: 'El campo de SOC a AGREGAR no puede estar vacío',
          });
          withError = true;
        } else {
          textAreaContent = this.textareaAdd.trim();
        }
      }
      if (commandType === 'del') {
        if (this.textareaDel.trim() === '') {
          this.$notify.error({
            title: 'Error',
            message: 'El campo de SOC a ELIMINAR no puede estar vacío',
          });
          withError = true;
        } else {
          textAreaContent = this.textareaDel.trim();
        }
      }
      if (withError === false) {
        if (textAreaContent !== '') {
          let orders;
          const ordersToNumbersTim = [];
          if (textAreaContent.indexOf(', ') !== -1) {
            orders = textAreaContent.split(', ');
          } else if (textAreaContent.indexOf('\n' !== -1)) {
            orders = textAreaContent.split('\n');
          } else if (textAreaContent.indexOf('\r' !== -1)) {
            orders = textAreaContent.split('\r');
          }
          orders.filter(e => e !== '').forEach((orderStringNumber) => {
            if (this.validateNumber(orderStringNumber.trim())) {
              ordersToNumbersTim.push(parseInt(orderStringNumber, 10));
            } else {
              ordersError.push(orderStringNumber);
            }
          });
          if (commandType === 'tim') {
            this.ordersToTim = ordersToNumbersTim;
            this.routeModify();
          }
          if (commandType === 'add' || commandType === 'del') {
            this.ordersToTim = ordersToNumbersTim;
            this.routeModAddDel(commandType);
          }
        }
        if (ordersError.length > 0) {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: `El formato de las siguientes subordenes es incorrecto: ${ordersError.join(', ')}`,
          });
        } else {
          // eslint-disable-next-line
          if (this.ordersToAdd.length < 1 && this.ordersToDelete.length < 1) {
            this.$message({
              message: 'TIM contiene las mismas SOC de la ruta, no es necesario modificar Ruta',
              type: 'warning',
              duration: 8000,
            });
            this.cleanOrdersTo();
            this.cleanTextArea();
          } else {
            this.dialog.checkOrder = true;
          }
        }
      }
    },
    reLoad() {
      this.$emit('reload');
    },
    getUpload(socs) {
      this.$emit('getUpload', socs, [this.idRouteModSoc]);
    },
    onCellBlur() {
      this.editing = null;
    },
    dialogEditS(row) {
      this.$emit('dialog-edit', row.id);
    },
    changePlate(id, plate) {
      this.$emit('dialog-change-plate', id, plate);
    },
    selectedAllPoint(id) {
      this.$emit('selectedAllPoint', id);
    },
    changeReplanning(row) {
      if (row.soc > 0) {
        this.$emit('lauch-replanning', row.id);
      } else {
        this.$message({
          type: 'warning',
          title: 'ADVERTENCIA',
          message: 'No se puede replanificar una ruta con 0 soc',
        });
      }
    },
    deactivateRoute(row) {
      this.$confirm('¿Quieres desactivar la ruta?', 'Confirmación', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(() => {
        const startedAt = startRumTiming();
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_activation_v2',
          action: 'deactivation_requested',
          status: 'attempt',
          context: { route_id: row.id },
        });
        const messageDeactive = this.$message({
          message: `Desactivando Ruta ${row.id}, espera un momento por favor`,
          duration: 0,
          showClose: true,
        });
        apiRequest({
          module: 'planning',
          service: 'deactivate_route_v2',
          pathparam: { id: row.id },
          params: { id: row.id },
        }).then((res) => {
          this.$notify({
            type: 'success',
            title: 'DESACTIVACIÓN REALIZADA',
            message: `Ruta Nº ${res.data.id} desactivada`,
          });
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_activation_v2',
            action: 'deactivation_completed',
            status: 'success',
            durationMs: getRumDuration(startedAt),
            context: { route_id: row.id },
          });
          const routeSelected = this.tableData.filter(route => route.id === row.id);
          routeSelected[0].active = false;
          messageDeactive.close();
        }).catch((error) => {
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_activation_v2',
            action: 'deactivation_completed',
            status: 'error',
            durationMs: getRumDuration(startedAt),
            context: {
              route_id: row.id,
              error_status: error.response ? error.response.status : null,
            },
          });
          if (error.response) {
            this.$notify({
              type: 'error',
              title: 'Error',
              message: error.response.data.message,
            });
          }
          const routeSelected = this.tableData.filter(route => route.id === row.id);
          routeSelected[0].active = true;
          messageDeactive.close();
        });
      }).catch(() => {
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_activation_v2',
          action: 'deactivation_cancelled',
          status: 'cancelled',
          context: { route_id: row.id },
        });
        const routeSelected = this.tableData.filter(route => route.id === row.id);
        routeSelected[0].active = true;
      });
    },
    confirmedRoute(row) {
      let invalidMessage = '';
      if (row.soc < 1) {
        invalidMessage = 'No se puede confirmar una ruta con 0 soc';
      } else if (row.confirmed) {
        invalidMessage = 'La ruta ya está confirmada';
      }
      if (invalidMessage === '') {
        this.$confirm('¿Quieres confirmar la ruta?', 'Confirmación', {
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
          type: 'warning',
        }).then(() => {
          const startedAt = startRumTiming();
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_confirmation_v2',
            action: 'confirmation_requested',
            status: 'attempt',
            context: { route_id: row.id },
          });
          const routeSelected = this.tableData.filter(route => route.id === row.id);
          routeSelected[0].confirmed = null;
          const messageConfirmed = this.$message({
            message: `Confirmando Ruta ${row.id}, espere un momento por favor`,
            duration: 0,
            showClose: true,
          });
          apiRequest({
            module: 'planning',
            service: 'confirm_shipment_route',
            pathparam: { id: row.id },
            params: { id: row.id },
          }).then((res) => {
            this.$notify({
              type: 'success',
              title: 'CONFIRMACIÓN REALIZADA',
              message: `Ruta Nº ${res.data.id} confirmada`,
            });
            trackBusinessFlow({
              module: 'planning',
              flow: 'route_confirmation_v2',
              action: 'confirmation_completed',
              status: 'success',
              durationMs: getRumDuration(startedAt),
              context: { route_id: row.id },
            });
            routeSelected[0].confirmed = true;
            messageConfirmed.close();
          }).catch((error) => {
            trackBusinessFlow({
              module: 'planning',
              flow: 'route_confirmation_v2',
              action: 'confirmation_completed',
              status: 'error',
              durationMs: getRumDuration(startedAt),
              context: {
                route_id: row.id,
                error_status: error.response ? error.response.status : null,
              },
            });
            if (error.response) {
              this.$notify({
                type: 'error',
                title: 'Error',
                message: error.response.data.message,
              });
            }
            routeSelected[0].confirmed = false;
            messageConfirmed.close();
          });
        }).catch(() => {
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_confirmation_v2',
            action: 'confirmation_cancelled',
            status: 'cancelled',
            context: { route_id: row.id },
          });
        });
      } else {
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_confirmation_v2',
          action: 'confirmation_blocked',
          status: 'blocked',
          context: {
            route_id: row.id,
            reason: invalidMessage,
          },
        });
        this.$message({
          type: 'warning',
          title: 'ADVERTENCIA',
          message: invalidMessage,
        });
      }
    },
    activeRoute(row) {
      let invalidMessage = '';
      if (row.soc < 1) {
        invalidMessage = 'No se puede activar una ruta con 0 soc';
      } else if (!row.confirmed) {
        invalidMessage = 'La ruta no está confirmada';
      } else if (row.finalized) {
        invalidMessage = 'La ruta ya fue finalizada';
      } else if (row.active && row.rtdb_uid !== null) {
        invalidMessage = 'La ruta ya está activa';
      }
      if (invalidMessage === '') {
        this.$confirm('¿Quieres activar la ruta?', 'Confirmación', {
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
          type: 'warning',
        }).then(() => {
          const startedAt = startRumTiming();
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_activation_v2',
            action: 'activation_requested',
            status: 'attempt',
            context: { route_id: row.id },
          });
          const routeSelected = this.tableData.filter(route => route.id === row.id);
          routeSelected[0].active = true;
          routeSelected[0].rtdb_uid = 'ok';
          const messageActive = this.$message({
            message: `Activando Ruta ${row.id}, espere un momento por favor`,
            duration: 0,
            showClose: true,
          });
          apiRequest({
            module: 'planning',
            service: 'activate_route',
            pathparam: { id: row.id },
            params: { id: row.id },
          }).then((res) => {
            this.$notify({
              type: 'success',
              title: 'ACTIVACIÓN REALIZADA',
              message: `Ruta Nº ${res.data.id} activada`,
            });
            trackBusinessFlow({
              module: 'planning',
              flow: 'route_activation_v2',
              action: 'activation_completed',
              status: 'success',
              durationMs: getRumDuration(startedAt),
              context: { route_id: row.id },
            });
            messageActive.close();
          }).catch((error) => {
            trackBusinessFlow({
              module: 'planning',
              flow: 'route_activation_v2',
              action: 'activation_completed',
              status: 'error',
              durationMs: getRumDuration(startedAt),
              context: {
                route_id: row.id,
                error_status: error.response ? error.response.status : null,
              },
            });
            if (error.response) {
              this.$notify({
                type: 'error',
                title: 'Error',
                message: error.response.data.message,
              });
            }
            routeSelected[0].active = false;
            messageActive.close();
          });
        }).catch(() => {
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_activation_v2',
            action: 'activation_cancelled',
            status: 'cancelled',
            context: { route_id: row.id },
          });
        });
      } else {
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_activation_v2',
          action: 'activation_blocked',
          status: 'blocked',
          context: {
            route_id: row.id,
            reason: invalidMessage,
          },
        });
        this.$message({
          type: 'warning',
          title: 'ADVERTENCIA',
          message: invalidMessage,
        });
      }
    },
    closeDialogTabs() {
      this.cleanTextArea();
    },
    cleanTextArea() {
      this.textareaTim = '';
      this.textareaAdd = '';
      this.textareaDel = '';
    },
    cleanOrdersTo() {
      this.ordersToAdd = [];
      this.ordersToDelete = [];
      this.ordersToTim = [];
    },
    tabClick(tab) {
      if (tab.name === 'tim') {
        this.button.showTim = true;
        this.button.showAdd = false;
        this.button.showDel = false;
      }
      if (tab.name === 'add') {
        this.button.showTim = false;
        this.button.showAdd = true;
        this.button.showDel = false;
      }
      if (tab.name === 'del') {
        this.button.showTim = false;
        this.button.showAdd = false;
        this.button.showDel = true;
      }
    },
    validateNumber(number) {
      if (number === undefined || number === null) {
        return true;
      }
      if (/(^[0-9]{8,16}$)/.test(number)) {
        return true;
      }
      return false;
    },
    routeModify() {
      for (let i = 0; i < this.ordersToTim.length; i += 1) {
        const found = this.subOrderList.some(item => item.code === this.ordersToTim[i]);
        if (found === false) this.ordersToAdd.push(this.ordersToTim[i]);
      }
      for (let i = 0; i < this.subOrderList.length; i += 1) {
        const found = this.ordersToTim.some(item => item === this.subOrderList[i].code);
        if (found === false) this.ordersToDelete.push(this.subOrderList[i].code);
      }
    },
    routeModAddDel(commandType) {
      if (commandType === 'add') {
        for (let i = 0; i < this.ordersToTim.length; i += 1) {
          this.ordersToAdd.push(this.ordersToTim[i]);
        }
      }
      if (commandType === 'del') {
        for (let i = 0; i < this.ordersToTim.length; i += 1) {
          this.ordersToDelete.push(this.ordersToTim[i]);
        }
      }
    },
    cancelModSoc() {
      this.cleanTextArea();
      this.cleanOrdersTo();
    },
    addOrderSoc() {
      // this.loading = true;
      this.dialog.checkOrder = false;
      this.ordersToAdd.forEach((el) => {
        this.ordersToEdit.add_suborders.push(el);
      });
      this.ordersToDelete.forEach((el) => {
        this.ordersToEdit.remove_suborders.push(el);
      });
      apiRequest({
        module: 'planning',
        service: 'addanddelete_suborders',
        pathparam: { id: this.idRouteModSoc },
        params: this.ordersToEdit,
      }).then((res) => {
        this.ordersToEdit.add_suborders = [];
        this.ordersToEdit.remove_suborders = [];
        this.resDataTim(res);
        if (res.data.add_success && res.data.add_success.length > 0) {
          this.getUpload(res.data.add_success);
        }
        // this.loading = false;
      }).catch((error) => {
        if (error.response) {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: error.response.data.message,
          });
        }
        // this.property.vehicle.patent = this.oldValue;
        this.loading = false;
      });
      this.cleanTextArea();
    },
  },
  computed: {
    visibleTableData() {
      if (this.hasSectors) {
        return this.tableData.filter(row => this.sectors.filter(sec => sec.active)
          .some(sec => row.sector_id === sec.id));
      }
      return this.tableData;
    },
    hasSectors() {
      return this.sectors.length > 0;
    },
    isEditing() {
      return this.editing !== null;
    },
    checkedCount() {
      return this.checkedRoutes.length;
    },
    checkedCountColor() {
      return this.checkedCount === this.maxChecked ? 'routes-counter red' : 'routes-counter';
    },
  },
};
</script>

<style lang="scss" scoped>
.table-content {
  .cell-item {
    font-size: 10px;
    white-space: nowrap;
    overflow: hidden;
    direction: rtl !important;
    text-overflow: ellipsis;
  }
}

.dialogSub {
  padding: 10px 40px 0 0;
  text-align: left;
  font-size: 1em;
  text-transform: uppercase;
  font-weight: 500;
  margin-top: 0;

  .el-icon-circle-plus {
    color: #F5A623;
    font-size: 1.4em;
    margin-right: 0.5em;
  }

  .el-icon-remove {
    color: #F5A623;
    font-size: 1.4em;
    margin-right: 0.5em;
  }

  .el-icon-success {
    color: #AAD500;
    font-size: 1.4em;
    margin-right: 0.5em;
  }

  .ordersListStyleDialog {
    font-size: 11px;
    text-align: left;
  }

  .dialogTotalTim {
    padding: 10px 40px 0 0;
    text-align: center;
    font-size: 1em;
    text-transform: uppercase;
    font-weight: 800;
    margin-top: 0;
  }
}

.totalItemTimSuss {
  color: white;
  font-size: 12px;
  background: #AAD500;
  border-radius: 100%;
  -moz-border-radius: 1em;
  -webkit-border-radius: 1em;
  display: inline-block;
  font-weight: bold;
  line-height: 1.3em;
  margin-right: 14px;
  margin-left: 10px;
  margin-top: 5px;
  text-align: center;
  width: 2.4em;
}

.input {
  margin: 8px 0 16px 0;
}

.dialogText {
  width: 85%;
  margin: auto;

  .focus {
    display: block;
  }
}

.dialogItem {
  width: 85%;
  font-size: 11px;
  text-align: left;
  margin: 5px 0 5px 20px;

  .focus {
    display: block;
  }
}

.focus {
  text-transform: uppercase;
  font-weight: 900;
  color: #AAD500;

  &.small {
    display: block;
    font-style: italic;
    margin-top: 0.5em;
    font-size: 0.85em;
  }
}

.dialogError {
  padding: 10px 40px 0 0;
  text-align: left;
  font-size: 1.2em;
  text-transform: uppercase;
  font-weight: 700;
  margin-top: 0;

  .el-icon-error {
    color: #f4511e;
    font-size: 1.2em;
    margin: 0 0.5em 0 0;
  }
}

.totalItemTim {
  color: white;
  font-size: 10px;
  background: #F5A623;
  border-radius: 100%;
  -moz-border-radius: 1em;
  -webkit-border-radius: 1em;
  display: inline-block;
  font-weight: bold;
  line-height: 1.3em;
  margin-right: 14px;
  margin-left: 10px;
  text-align: center;
  width: 2.4em;
}

.change-plate {
  .fa-truck {
    color: $fb-green;
  }

  .is-disabled>span>i {
    color: #C0C4CC;
  }

  span {
    margin-left: 5px;
    font-size: 10px;
  }
}

/* empieza el fideo*/
.btnSearch {
  height: 40px;
}

.rowRoutePatent {
  display: table;
  margin-top: -20px;
  height: 20px;
  margin-left: 30px;
  margin-bottom: 0;
  text-align: left;
}

.el-icon-truck {
  margin-right: 10px;
  font-size: 20px;
  color: #c0c4cc;
  display: table-cell;
  vertical-align: middle;
}

.titleStyle {
  font-size: 11px;
  color: #707070;
  text-transform: uppercase;
  margin: 0 30px 0 0;
  font-weight: normal;
}

.titleStyleCV {
  font-size: 12px;
  color: #9B9B9B;
  text-transform: uppercase;
  margin: 15px 0 5px 50px;
  font-weight: normal;
  text-align: left;
}

.contentMap {
  width: 100%;
  height: 30vh !important;
}

.el-input__inner {
  width: 200px;
}

el-form el-form--inline {
  text-align: left;
}

.topTitle {
  text-transform: uppercase;
  font-size: 14px;
  text-align: left;
  margin: 0 0 1.2em;
}

.focus {
  text-transform: uppercase;
  font-weight: 900;
  color: #AAD500;

  &.small {
    display: block;
    font-style: italic;
    margin-top: 0.5em;
    font-size: 0.85em;
  }
}

.input {
  margin: 8px 0 16px 0;
}

.dialogText {
  width: 85%;
  margin: auto;

  .focus {
    display: block;
  }
}

.dialogItem {
  width: 85%;
  font-size: 11px;
  text-align: left;
  margin: 5px 0 5px 20px;

  .focus {
    display: block;
  }
}

.btnBottom {
  margin-top: 10px;
  float: right;
}

.tableStyle {
  box-sizing: border-box;
  overflow: hidden;
}

.grey {
  background-color: #606266;
  align-self: flex-end;
  height: 40px;
}

.titleStyleNumRoutes {
  font-size: 13px;
  color: #AAD500;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0 0 10px 0;
}

.linkStyle {
  color: #AAD500;
  border: none;
  font-weight: 600;
  font-size: 15px;
  outline: none;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.0);
  margin: 0;
  padding: 0;
}

.dialogRec {
  padding: 0 40px;
  font-size: 1em;
  text-transform: uppercase;
  font-weight: 700;
  margin: 30px 0 0 0;
}

.dialogSub {
  padding: 10px 40px 0 0;
  text-align: left;
  font-size: 1em;
  text-transform: uppercase;
  font-weight: 500;
  margin-top: 0;

  .el-icon-circle-plus {
    color: #F5A623;
    font-size: 1.4em;
    margin-right: 0.5em;
  }

  .el-icon-remove {
    color: #F5A623;
    font-size: 1.4em;
    margin-right: 0.5em;
  }

  .el-icon-success {
    color: #AAD500;
    font-size: 1.4em;
    margin-right: 0.5em;
  }

  .ordersListStyleDialog {
    font-size: 11px;
    text-align: left;
  }

  .dialogTotalTim {
    padding: 10px 40px 0 0;
    text-align: center;
    font-size: 1em;
    text-transform: uppercase;
    font-weight: 800;
    margin-top: 0;
  }
}

.dialogError {
  padding: 10px 40px 0 0px;
  text-align: left;
  font-size: 1.2em;
  text-transform: uppercase;
  font-weight: 700;
  margin-top: 0;

  .el-icon-error {
    color: #f4511e;
    font-size: 1.2em;
    margin: 0 0.5em 0 0;
  }
}

.totalItemTim {
  color: white;
  font-size: 10px;
  background: #F5A623;
  border-radius: 100%;
  -moz-border-radius: 1em;
  -webkit-border-radius: 1em;
  display: inline-block;
  font-weight: bold;
  line-height: 1.3em;
  margin-right: 14px;
  margin-left: 10px;
  text-align: center;
  width: 2.4em;
}

.totalItemTimSuss {
  color: white;
  font-size: 12px;
  background: #AAD500;
  border-radius: 100%;
  -moz-border-radius: 1em;
  -webkit-border-radius: 1em;
  display: inline-block;
  font-weight: bold;
  line-height: 1.3em;
  margin-right: 14px;
  margin-left: 10px;
  margin-top: 5px;
  text-align: center;
  width: 2.4em;
}

.ordersListStyleDialog {
  margin-left: 10px;
}

.dialogItemSuss {
  width: 85%;
  font-size: 11px;
  text-align: left;
  margin: 5px 0 5px 30px;

  .focus {
    display: block;
  }
}

.clickeable {
  font-size: 7px;
  padding-top: 1px;
  margin-right: 3px;
  height: 23px;
  float: right;
  color: darkgray;
  cursor: pointer;
  animation: jumps .5s infinite;
}

.clickeable:hover {
  color: #AAD500;
  animation: none;
}

@keyframes jumps {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(4px);
  }

  100% {
    transform: translateY(0px);
  }
}

td {
  padding: 2px 0px !important;
}

.point-map {
  color: #E6A23C;
  font-size: 8px;
  top: -2px;
}

.rotate-1 {
  webkit-animation: rotating 5s linear infinite;
  animation: rotating 5s linear infinite;
}

.el-icon-refresh-right {
  padding: 3px;
  color: white;
  border-radius: 50%;
  background-color: #09558f;
}

.refresh-send {
  font-size: 15px;
  color: #AAD500;
  background-color: transparent;
}

.routes-counter {
  padding: 3px;
  color: #94969a;
}

.red {
  color: #ff9a00;
}

.select-routes {
  i {
    color: #AAD500;
    font-size: 16px;
    font-weight: 900;
    vertical-align: middle;
  }
}

.volume-percent {
  float: left;
  margin-right: 5px;
}

.select-all-soc {
  padding: 0;
  font-size: 10.5px;
}

.all-color {
  color: #ffb100;
}

.btn-active,
.btn-confirmed {
  width: 70px;
  padding: 4px 0;
}

.btn-confirmed {
  background-color: #ffb100 !important;
}
</style>
